import React from 'react';
import { useManifest } from '../../services/Firestore/Resources';
import { createUseStyles } from 'react-jss';
import { RenderStateTitle } from '../State/State';
const useStyles = createUseStyles({
  details: {
    position: 'absolute',
    top: '100%',
    left: '0',
    backgroundColor: 'white',
    minWidth: '300px',
    borderRadius: '6px',
    border: '1px solid black',
    padding: '10px',
    zIndex: '10',
  },
  empty: {
    fontStyle: 'italic',
    color: 'red',
  },
  detailsTitle: {
    fontWeight: 'bold',
  },
  detailsItem: {
    display: 'block',
  },
});
export const ManifestHoverItemDetails = ({ id }) => {
  const [manifest, loadingManifest] = useManifest(id);
  const classes = useStyles();

  if (loadingManifest) {
    return <span className={classes.details}>Loading items</span>;
  }
  return (
    <span className={classes.details}>
      <div className={classes.detailsTitle}>
        {RenderStateTitle(manifest?.state, manifest?.stateUpdated)}
      </div>
      {manifest.items &&
        Object.values(manifest.items).map((item) => (
          <em className={classes.detailsItem} key={item.id}>
            {item.description + ' : ' + item.serialNumber}
          </em>
        ))}
      {manifest.items?.length === 0 && (
        <span className={classes.empty}>No Items on this manifest</span>
      )}
    </span>
  );
};
